import { findRecursive } from '@/mm/utils.js'
import { washDataArabic, washDataArabicAlign, ArabicEach } from '@/mm/utils.js'
import { createMuiltLanguagesJson } from "@/components/widgets/nav/repeatNumber.js";
export function washData_footModule(walkedNode) {
  const ProNode = findRecursive(
    walkedNode.list,
    (item) => item.componentName === 'contact_bottom',
    'list'
  )
  if (ProNode && walkedNode) {
    if (ProNode.actions) {
      const attributeIndex = ProNode?.actions.findIndex((item) => item === 'attribute')
      const hasContactBottom = ProNode.actions.includes('contactBottom')
      if (attributeIndex !== -1) {
        ProNode.actions[attributeIndex] = 'contactBottom'
      } else if (!hasContactBottom) {
        ProNode.actions.unshift('contactBottom')
      }
    }
    if (walkedNode._type === 'foot_module3') {
      walkedNode.list[1].list.forEach(col => {
        const titleNode = findRecursive(
          col.list,
          (item) => item.cusClass === 'title_arrow',
          'list'
        )
        if (!titleNode) return
        titleNode.data.design.title_textAlign = {
          diannao: createMuiltLanguagesJson('left', { 'rtl': 'right' }),
          pingban: createMuiltLanguagesJson('left', { 'rtl': 'right' }),
          shouji: createMuiltLanguagesJson('left', { 'rtl': 'right' })
        }
        const bottomNavNode = findRecursive(
          col.list,
          (item) => item.componentName === 'bottomNav',
          'list'
        )
        console.log(bottomNavNode, 'bottomNavNode');
        if (bottomNavNode && typeof bottomNavNode.data.design.self_paddingLeft.diannao !== 'object') {
          let bottomNavpaddingLeft = bottomNavNode.data.design.self_paddingLeft
          let bottomNavpaddingRight = bottomNavNode.data.design.self_paddingRight
          bottomNavNode.data.design.self_paddingLeft = {
            diannao: createMuiltLanguagesJson(bottomNavpaddingLeft.diannao, { 'rtl': bottomNavpaddingRight.diannao }),
            pingban: createMuiltLanguagesJson(bottomNavpaddingLeft.pingban, { 'rtl': bottomNavpaddingRight.pingban }),
            shouji: createMuiltLanguagesJson(bottomNavpaddingLeft.shouji, { 'rtl': bottomNavpaddingRight.shouji })
          }
          bottomNavNode.data.design.self_paddingRight = {
            diannao: createMuiltLanguagesJson(bottomNavpaddingRight.diannao, { 'rtl': bottomNavpaddingLeft.diannao }),
            pingban: createMuiltLanguagesJson(bottomNavpaddingRight.pingban, { 'rtl': bottomNavpaddingLeft.pingban }),
            shouji: createMuiltLanguagesJson(bottomNavpaddingRight.shouji, { 'rtl': bottomNavpaddingLeft.shouji })
          }
        }
      })
      const imgNode = findRecursive(
        walkedNode.list,
        (item) => item.componentName === 'image_image1',
        'list'
      )
      if (imgNode && !imgNode.actions.includes('translate')) {
        imgNode.actions.push('translate')
      }
    }
    if (walkedNode._type === 'foot_module1') {
      const rowColNode = findRecursive(
        walkedNode.list,
        (item) => item.componentName === 'rowCol',
        'list'
      )
      walkedNode.list[0].list.forEach(col => {
        const titleNode = findRecursive(
          col.list,
          (item) => item.cusClass === 'title_arrow',
          'list'
        )
        if(!titleNode)return
        titleNode.data.design.title_textAlign = {
          diannao: createMuiltLanguagesJson('left', { 'rtl': 'right' }),
          pingban: createMuiltLanguagesJson('left', { 'rtl': 'right' }),
          shouji: createMuiltLanguagesJson('left', { 'rtl': 'right' })
        }

        const bottomNavNode = findRecursive(
          col.list,
          (item) => item.componentName === 'bottomNav',
          'list'
        )
        if (bottomNavNode && typeof bottomNavNode.data.design.self_paddingLeft.diannao !== 'object') {
          let bottomNavpaddingLeft = bottomNavNode.data.design.self_paddingLeft
          let bottomNavpaddingRight = bottomNavNode.data.design.self_paddingRight
          bottomNavNode.data.design.self_paddingLeft = {
            diannao: createMuiltLanguagesJson(bottomNavpaddingLeft.diannao, { 'rtl': bottomNavpaddingRight.diannao }),
            pingban: createMuiltLanguagesJson(bottomNavpaddingLeft.pingban, { 'rtl': bottomNavpaddingRight.pingban }),
            shouji: createMuiltLanguagesJson(bottomNavpaddingLeft.shouji, { 'rtl': bottomNavpaddingRight.shouji })
          }
          bottomNavNode.data.design.self_paddingRight = {
            diannao: createMuiltLanguagesJson(bottomNavpaddingRight.diannao, { 'rtl': bottomNavpaddingLeft.diannao }),
            pingban: createMuiltLanguagesJson(bottomNavpaddingRight.pingban, { 'rtl': bottomNavpaddingLeft.pingban }),
            shouji: createMuiltLanguagesJson(bottomNavpaddingRight.shouji, { 'rtl': bottomNavpaddingLeft.shouji })
          }
        }
      })
      const bottomNav1 = findRecursive(
        rowColNode.list[1].list,
        (item) => item.componentName === 'bottomNav',
        'list'
      )
      const bottomNav2 = findRecursive(
        rowColNode.list[2].list,
        (item) => item.componentName === 'bottomNav',
        'list'
      )
      const bottomForm = findRecursive(
        walkedNode.list,
        (item) => item.componentName === 'form_bottom_double',
        'list'
      )
      bottomNav1.actions = [
        'attribute',
        {
          name: 'design',
          config: {
            分组1: [
              'nav_fontFamily',
              'nav_fontSize',
              'nav_color',
              'nav_textStyle',
              'listIcon_icon',
              'nav_textAlign',
              'listIcon_color',
              'listIcon_fontSize',
              'nav_lineHeight',
              'navList_letterSpace',
              'self_padding'
            ]
          }
        },
        'hover'
      ]
      bottomNav2.actions = [
        'attribute',
        {
          name: 'design',
          config: {
            分组1: [
              'nav_fontFamily',
              'nav_fontSize',
              'nav_color',
              'nav_textStyle',
              'listIcon_icon',
              'nav_textAlign',
              'listIcon_color',
              'listIcon_fontSize',
              'nav_lineHeight',
              'navList_letterSpace',
              'self_padding'
            ]
          }
        },
        'hover'
      ]
      bottomForm.actions = ['design', 'hover', 'translate']
      const submit = bottomForm.data.design
      const formBorder = bottomForm.data.hover
      if (!submit.submitButton_text || submit.submitButton_text == 'Send') {
        submit.submitButton_text = '{{inquiry_submit_btn}}'
      }
      if (!formBorder['input_hoverBorderTopWidth']) {
        formBorder['input_hoverBorderTopWidth'] = {
          diannao: 1,
          pingban: 1,
          shouji: 1
        }
      }
      if (!formBorder['input_hoverBorderLeftWidth'] && !formBorder['input_hoverBorderRightWidth'] && formBorder['input_hoverBorderTopWidth'].diannao == 0) {
        formBorder['input_hoverBorderTopWidth'] = {
          diannao: 1,
          pingban: 1,
          shouji: 1
        }
      }
      if (!formBorder['input_hoverBorderBottomWidth']) {
        formBorder['input_hoverBorderBottomWidth'] = {
          diannao: 1,
          pingban: 1,
          shouji: 1
        }
      }
      if (!formBorder['input_hoverBorderRightWidth']) {
        formBorder['input_hoverBorderRightWidth'] = {
          diannao: 1,
          pingban: 1,
          shouji: 1
        }
      }
      if (!formBorder['input_hoverBorderLeftWidth']) {
        formBorder['input_hoverBorderLeftWidth'] = {
          diannao: 1,
          pingban: 1,
          shouji: 1
        }
      }

    }
    if (walkedNode._type === 'foot_module2') {

      walkedNode.list[0].list.forEach(col => {
        const titleNode = findRecursive(
          col.list,
          (item) => item.cusClass === 'title_arrow',
          'list'
        )
        if (!titleNode) return
          titleNode.data.design.title_textAlign = {
            diannao: createMuiltLanguagesJson('left', { rtl: 'right' }),
            pingban: createMuiltLanguagesJson('left', { rtl: 'right' }),
            shouji: createMuiltLanguagesJson('left', { rtl: 'right' })
          }

        const bottomNavNode = findRecursive(
          col.list,
          (item) => item.componentName === 'bottomNav',
          'list'
        )
        if (bottomNavNode && typeof bottomNavNode.data.design.self_paddingLeft.diannao !== 'object') {
          let bottomNavpaddingLeft = bottomNavNode.data.design.self_paddingLeft
          let bottomNavpaddingRight = bottomNavNode.data.design.self_paddingRight
          bottomNavNode.data.design.self_paddingLeft = {
            diannao: createMuiltLanguagesJson(bottomNavpaddingLeft.diannao, { 'rtl': bottomNavpaddingRight.diannao }),
            pingban: createMuiltLanguagesJson(bottomNavpaddingLeft.pingban, { 'rtl': bottomNavpaddingRight.pingban }),
            shouji: createMuiltLanguagesJson(bottomNavpaddingLeft.shouji, { 'rtl': bottomNavpaddingRight.shouji })
          }
          bottomNavNode.data.design.self_paddingRight = {
            diannao: createMuiltLanguagesJson(bottomNavpaddingRight.diannao, { 'rtl': bottomNavpaddingLeft.diannao }),
            pingban: createMuiltLanguagesJson(bottomNavpaddingRight.pingban, { 'rtl': bottomNavpaddingLeft.pingban }),
            shouji: createMuiltLanguagesJson(bottomNavpaddingRight.shouji, { 'rtl': bottomNavpaddingLeft.shouji })
          }
        }
      })
      const rowColNode = findRecursive(
        walkedNode.list,
        (item) => item.componentName === 'rowCol',
        'list'
      )
      const bottomNav0 = findRecursive(
        rowColNode.list[0].list,
        (item) => item.componentName === 'bottomNav',
        'list'
      )
      const bottomNav1 = findRecursive(
        rowColNode.list[1].list,
        (item) => item.componentName === 'bottomNav',
        'list'
      )

      bottomNav0.actions = [
        'attribute',
        {
          name: 'design',
          config: {
            分组1: [
              'nav_fontFamily',
              'nav_fontSize',
              'nav_color',
              'nav_textStyle',
              'listIcon_icon',
              'nav_textAlign',
              'listIcon_color',
              'listIcon_fontSize',
              'nav_lineHeight',
              'navList_letterSpace',
              'self_padding'
            ]
          }
        },
        'hover'
      ]
      bottomNav1.actions = [
        'attribute',
        {
          name: 'design',
          config: {
            分组1: [
              'nav_fontFamily',
              'nav_fontSize',
              'nav_color',
              'nav_textStyle',
              'listIcon_icon',
              'nav_textAlign',
              'listIcon_color',
              'listIcon_fontSize',
              'nav_lineHeight',
              'navList_letterSpace',
              'self_padding'
            ]
          }
        },
        'hover'
      ]
    }
    if (walkedNode._type === 'foot_module3') {

      // const rowColNode = findRecursive(
      //   walkedNode.list[1],
      //   (item) => item.componentName === 'rowCol',
      //   'list'
      // )
      const bottomNav0 = findRecursive(
        walkedNode.list[1].list[0].list,
        (item) => item.componentName === 'bottomNav',
        'list'
      )
      const bottomNav1 = findRecursive(
        walkedNode.list[1].list[1].list,
        (item) => item.componentName === 'bottomNav',
        'list'
      )

      bottomNav0.actions = [
        'attribute',
        {
          name: 'design',
          config: {
            分组1: [
              'nav_fontFamily',
              'nav_fontSize',
              'nav_color',
              'nav_textStyle',
              'listIcon_icon',
              'nav_textAlign',
              'listIcon_color',
              'listIcon_fontSize',
              'nav_lineHeight',
              'navList_letterSpace',
              'self_padding'
            ]
          }
        },
        'hover'
      ]
      bottomNav1.actions = [
        'attribute',
        {
          name: 'design',
          config: {
            分组1: [
              'nav_fontFamily',
              'nav_fontSize',
              'nav_color',
              'nav_textStyle',
              'listIcon_icon',
              'nav_textAlign',
              'listIcon_color',
              'listIcon_fontSize',
              'nav_lineHeight',
              'navList_letterSpace',
              'self_padding'
            ]
          }
        },
        'hover'
      ]
    }
    if (walkedNode._type === 'foot_module4') {

      walkedNode.list[0].list.forEach(col => {
        const titleNode = findRecursive(
          col.list,
          (item) => item.cusClass === 'title_arrow',
          'list'
        )
        if (!titleNode) return
        titleNode.data.design.title_textAlign = {
          diannao: createMuiltLanguagesJson('left', { 'rtl': 'right' }),
          pingban: createMuiltLanguagesJson('left', { 'rtl': 'right' }),
          shouji: createMuiltLanguagesJson('left', { 'rtl': 'right' })
        }
        const bottomNavNode = findRecursive(
          col.list,
          (item) => item.componentName === 'bottomNav',
          'list'
        )
        if (bottomNavNode && typeof bottomNavNode.data.design.self_paddingLeft.diannao !== 'object') {
          let bottomNavpaddingLeft = bottomNavNode.data.design.self_paddingLeft
          let bottomNavpaddingRight = bottomNavNode.data.design.self_paddingRight
          bottomNavNode.data.design.self_paddingLeft = {
            diannao: createMuiltLanguagesJson(bottomNavpaddingLeft.diannao, { 'rtl': bottomNavpaddingRight.diannao }),
            pingban: createMuiltLanguagesJson(bottomNavpaddingLeft.pingban, { 'rtl': bottomNavpaddingRight.pingban }),
            shouji: createMuiltLanguagesJson(bottomNavpaddingLeft.shouji, { 'rtl': bottomNavpaddingRight.shouji })
          }
          bottomNavNode.data.design.self_paddingRight = {
            diannao: createMuiltLanguagesJson(bottomNavpaddingRight.diannao, { 'rtl': bottomNavpaddingLeft.diannao }),
            pingban: createMuiltLanguagesJson(bottomNavpaddingRight.pingban, { 'rtl': bottomNavpaddingLeft.pingban }),
            shouji: createMuiltLanguagesJson(bottomNavpaddingRight.shouji, { 'rtl': bottomNavpaddingLeft.shouji })
          }
        }
        const conNavNode = findRecursive(
          col.list,
          (item) => item.class === 'con1',
          'list'
        )
        if (conNavNode && typeof conNavNode.data.design.self_marginLeft.diannao !== 'object') {
          let con1MarginLeft = conNavNode.data.design.self_marginLeft
          let con1MarginRight = conNavNode.data.design.self_marginRight
          conNavNode.data.design.self_marginLeft = {
            diannao: createMuiltLanguagesJson(con1MarginLeft.diannao, { 'rtl': con1MarginRight.diannao }),
            pingban: createMuiltLanguagesJson(con1MarginLeft.pingban, { 'rtl': con1MarginRight.pingban }),
            shouji: createMuiltLanguagesJson(con1MarginLeft.shouji, { 'rtl': con1MarginRight.shouji })
          }
          conNavNode.data.design.self_marginRight = {
            diannao: createMuiltLanguagesJson(con1MarginRight.diannao, { 'rtl': con1MarginLeft.diannao }),
            pingban: createMuiltLanguagesJson(con1MarginRight.pingban, { 'rtl': con1MarginLeft.pingban }),
            shouji: createMuiltLanguagesJson(con1MarginRight.shouji, { 'rtl': con1MarginLeft.shouji })
          }
        }
      })
      const rowColNode = findRecursive(
        walkedNode.list,
        (item) => item.componentName === 'rowCol',
        'list'
      )
      const bottomNav = findRecursive(
        rowColNode.list,
        (item) => item.componentName === 'bottomNav',
        'list'
      )

      bottomNav.actions = [
        'attribute',
        {
          name: 'design',
          config: {
            分组1: [
              'nav_fontFamily',
              'nav_fontSize',
              'nav_color',
              'nav_textStyle',
              'listIcon_icon',
              'nav_textAlign',
              'listIcon_color',
              'listIcon_fontSize',
              'nav_lineHeight',
              'navList_letterSpace',
              'self_padding'
            ]
          }
        },
        'hover'
      ]
    }
  }
}
